<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
               
        <!-- Mentions legales -->
<section id="faqs-1" class="bg-fixed bg-lightgrey wide-60 faqs-section division contact-bck">						
    <div class="container">


        <!-- SECTION TITLE -->	
        <div class="row">	
            <div class="col-md-10 offset-md-1 section-title">
                <!-- Title 	-->	
                <h2 class="h2-lg">Vos agences Weblogy, plus proches de vous !</h2>            
            <div>     
           
              <VueMultiselect  
                class="mselect" 
                v-model="value" 
                placeholder="Recherche une Agence par sa localité" 
                selectLabel=""
                deselectLabel=""
                selectedLabel="selectionné"
                label="nom" 
                track-by="id" 
                :options="localities" 
                :multiple="false" 
                @select="onSelect"
                >
              </VueMultiselect>


            </div>
            <!--<div>la valeur : {{ value.id }}</div>       -->            
            </div>

            <!-- End row --> 	
        </div>	 <!-- END SECTION TITLE -->	

        <div class="row"> 

            <section class="card__list row">

                <div class="card__box col-md-6 col-sm-12">
                    <div class="card">
                    <div class="card__img">
                        <a href="#" target="_blank"><img class="card__img-preview" src="@/assets/images/weblogy-cocody.webp" alt="Image name"></a>
                        <div class="card-img-overlay"><span class="ouvert badge badge-pill badge-danger">Ouvert</span> </div>
                    </div>
                    <div class="card__content">
                        <h4 class="card__title"><a href="https://www.google.com/maps/place/Weblogy+C%C3%B4te+d'Ivoire+(Abidjan.net)/@5.3322343,-4.0024345,17z/data=!3m1!4b1!4m5!3m4!1s0xfc1eb9b0eb06a1d:0xeafaab6e1a223561!8m2!3d5.3322343!4d-4.0002405" target="_blank" class="title_c">Agence Weblogy Cocody</a></h4>
                        <p class="card__text"><i class="fa fa-map-marker" aria-hidden="true"></i> Cocody Ambassade</p>
                        <p class="card__description">Lundi - Samedi : 08h - 21h | Dimanche : 13h - 20h</p>
                        <div class="card__bottom">
                        <div class="options">
                            <span class="date">
                            <i class="fa fa-phone" aria-hidden="true"></i> 25 22 010 114</span>
                            
                        </div>
                        
                    </div>
                    </div>
                </div>
                </div><!-- /card__box -->

                <div class="card__box col-md-6 col-sm-12">
                    <div class="card">
                    <div class="card__img">
                        <img class="card__img-preview" src="@/assets/images/w-plateau.webp" alt="Image name">
                        <div class="card-img-overlay"><span class="ouvert badge badge-pill badge-danger">Ouvert</span> </div>
                    </div>
                    <div class="card__content">
                        <h4 class="card__title"><a href="https://www.google.com/maps/place/Weblogy+C%C3%B4te+d'Ivoire/@5.3215983,-4.0145245,17z/data=!3m1!4b1!4m5!3m4!1s0xfc1ebbec3db523b:0xf50523053360298e!8m2!3d5.3215983!4d-4.0123305" target="_blank" class="title_c">Agence Weblogy Plateau</a></h4>
                        <p class="card__text"><i class="fa fa-map-marker" aria-hidden="true"></i> Résidence Pelieu</p>
                        <p class="card__description">Lundi - Vendredi : 08h - 18h | Samedi : 09h - 13h</p>
                        <div class="card__bottom">
                        <div class="options">
                            <span class="date">
                            <i class="fa fa-phone" aria-hidden="true"></i> 27 20 33 49 52</span>
                            
                        </div>
                        <!--<div class="card__price"> 59.00$</div>-->
                    </div>
                    </div>
                </div>
                </div><!-- /card__box -->

                

                <div class="card__box col-md-6 col-sm-12 offset-md-3 offset-lg-3">
                    <div class="card">
                    <div class="card__img">
                        <img class="card__img-preview" src="@/assets/images/prima.webp" alt="Image name">
                        <div class="card-img-overlay"><span class="ouvert badge badge-pill badge-danger">Ouvert</span> </div>
                    </div>
                    <div class="card__content">
                        <h4 class="card__title"><a href="https://www.google.com/maps/place/Prima+Center/@5.2951303,-3.9849516,17.97z/data=!4m5!3m4!1s0xfc1eeaa2fb3afbf:0x1456a227925d7ee3!8m2!3d5.295272!4d-3.983574" target="_blank" class="title_c">Agence Weblogy Zone 4</a></h4>
                        <p class="card__text"><i class="fa fa-map-marker" aria-hidden="true"></i> Prima Center</p>
                        <p class="card__description">Lundi - Vendredi : 08h - 18h | Samedi : 09H - 13H</p>
                        <div class="card__bottom">
                        <div class="options">
                            <span class="date">
                            <i class="fa fa-phone" aria-hidden="true"></i> 25 21 00 60 88</span>
                        </div>
                        
                    </div>
                    </div>
                </div>
                </div><!-- /card__box -->

                <div class="card__box col-md-6 col-sm-12">
                    <div class="card">
                    <div class="card__img">
                        <img class="card__img-preview" src="@/assets/images/radisson.webp" alt="Image name">
                        <div class="card-img-overlay"><span class="ferme badge badge-pill badge-danger">Fermé</span> </div>
                    </div>
                    <div class="card__content">
                        <h4 class="card__title"><a href="https://www.google.com/maps/place/Radisson+Blu+Hotel,+Abidjan+Airport/@5.2589738,-3.9459916,15.27z/data=!4m5!3m4!1s0xfc1ee4d7f9e39cb:0xc635f50f8691f4f2!8m2!3d5.2579444!4d-3.937456" target="_blank" class="title_c">Agence Weblogy Radisson Blu</a></h4>
                        <p class="card__text"><i class="fa fa-map-marker" aria-hidden="true"></i> Hôtel Radisson Blu</p>
                        <p class="card__description">Lundi - Vendredi : 08h - 18h</p>
                        <div class="card__bottom">
                        <div class="options">
                            <span class="date">
                            <i class="fa fa-phone" aria-hidden="true"></i> 05 75 208 110</span>
                        </div>
                        
                    </div>
                    </div>
                </div>
                </div>

                <div class="card__box col-md-6 col-sm-12 ">
                    <div class="card">
                    <div class="card__img">
                        <img class="card__img-preview" src="@/assets/images/agora.webp" alt="Image name">
                        <div class="card-img-overlay"><span class="ferme badge badge-pill badge-danger">Fermé</span> </div>
                    </div>
                    <div class="card__content">
                        <h4 class="card__title"><a href="https://www.google.com/maps/place/Agora+Koumassi+centre+sportif+socio-culturel/@5.2875489,-3.9648499,16.75z/data=!4m5!3m4!1s0xfc1ef4f28d7281f:0xa2324ced14932932!8m2!3d5.2873916!4d-3.962652" class="title_c">Agence Weblogy Koumassi</a></h4>
                        <p class="card__text"><i class="fa fa-map-marker" aria-hidden="true"></i> Complexe Sportif Agora</p>
                        <p class="card__description">Lundi - Vendredi : 08h - 18h</p>
                        <div class="card__bottom">
                        <div class="options">
                            <span class="date">
                            <i class="fa fa-phone" aria-hidden="true"></i> 05 54 175 175</span>
                        </div>
                        
                    </div>
                    </div>
                </div>
                </div>
                        
                        

                      
                        <!-- /card__box -->
</section>    
                    
                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">	

                            <!-- Text -->
                            <p></p>
                            <p class="p-md">Nos équipes commerciales et techniques sont à votre écoute pour<br> répondre rapidement à tous vos besoins.
                            </p>

                            <!-- Button -->						
                            <RouterLink to="nous-contacter" class="btn btn-lightorange ">Contacter le service client</RouterLink>

                        </div>
						</div>

                </div>	<!-- End row -->	

            </div>	   <!-- End container -->		
			</section>
        <!-- Mentions legales -->

       

        <footer_menu></footer_menu>
    </div>

</template>

<script>

import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';

import VueMultiselect from 'vue-multiselect'
import axios  from 'axios';
//import { response } from 'express';

export default{
    name :'nos_cartes',
    components:{
        VueMultiselect,

      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu,
     
    },

    data() {
    return {
      value: [],
      localities: [],
      
    };
  },

    methods: {
   
      getLocalities(){
        axios.get('https://carte.abidjan.net/assets-apaym/liste_localites.php').then(res => {
            console.log('>>>>>>>>>Success')
            this.localities = res.data
            console.log(this.localities)
        }).catch(error=>{
            console.log('>>>>>>>>> Error')
            console.log(error.response)
        })
    },

    onSelect(selectedOption) {
      window.localStorage.setItem("id_point_de_vente", selectedOption.id);
      this.$router.push("/agences/"+ this.slugify(selectedOption.nom));
    },

    slugify(str)
            {
                str = str.replace(/^\s+|\s+$/g, '');

                // Make the string lowercase
                str = str.toLowerCase();

                // Remove accents, swap ñ for n, etc
                var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
                var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
                for (var i=0, l=from.length ; i<l ; i++) {
                    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
                }

                // Remove invalid chars
                str = str.replace(/[^a-z0-9 -]/g, '')
                    // Collapse whitespace and replace by -
                    .replace(/\s+/g, '-')
                    // Collapse dashes
                    .replace(/-+/g, '-');

                return str;
            }, 

  },
  
  created() {
    this.getLocalities()
  },

}

</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>


.mselect{
    max-width: 440px;
    margin: auto;
    margin-top: 40px;
}

.ouvert{
    background: #4cb641;
    border-radius: 12px;
    border: none;
    color: #fff;
}
.ferme{
    background: #da2c2c;
    border-radius: 12px;
    border: none;
    color: #fff;
}

.options{
    font-weight: bold;
    font-size: 1rem;
    margin-top: 7px;
    color: #261b64;
}
.fa-map-marker, .fa-phone{
    color: #ff9e00;  
}
.title_c{
    color: #261b64;
}
.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
.card__list {
  max-width: 1200px;
  margin: 2rem auto;
}
.card {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  flex-direction: row;
  height: 170px;
  margin-bottom: 1.5rem;
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
          box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.25s ease-in;
}
.card:hover  {
  transform: translateY(-5px);
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
}
@media(max-width: 768px) {
  .card {
    flex-direction: column !important;
    height: auto;
  }
}
.card__img{
  flex: 1 30%;
  -webkit-flex: 1 30%;
  overflow:hidden;
  position: relative;
  border-right: 1px solid #efefef;
}
.card__img-preview {
  display: block;
  object-fit: cover;
  margin: 0 auto;
  min-width: 150px;
  max-width: 100%;
  min-height: 100%;
  transition: all 0.5s ease 0s;
}
.card__img-preview:hover {
  transform: scale(1.5);
}
.card-img-overlay {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.5rem;
}
.card__content {
  flex: 1 70%;
  -webkit-flex: 1 70%;
  padding: 0.8rem;
}
.card__title {
	font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
  margin-bottom: 7px;
}
.card__text {
	font-size: 0.9rem;
  margin: 0;
  font-weight: 400;
}
.card__description {
	font-size: 0.9rem;
    margin: 0;
    margin-top: 1rem;
  color: #888;
	overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  max-height: 2rem;
  line-height: 1rem;
}
.card__bottom {
	display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
	align-content: center;
	-webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
	border-top: 1px solid #efefef;
  text-align: right;
	padding-top: 0.5rem;
	margin-top: 1rem;
	font-size: 0.8rem;
	color: #888;
}
.card__price {
  color: #E35354;
  text-align: center;
  font-weight: 700;
  font-size: 1rem;
}

</style>
